import create from '~/misc/create';
import types from './types';
import get from 'lodash/get';
import {companyBroker} from '~/api/company';
import resourceId from '~/misc/resourceId';

// save-broker
export const resourcesSaveBroker = (data) => (dispatch, getState) => {
  const broker = get(getState().brokers, ['byDOT', data.dot]);
  const loadsIdentity = broker && broker.loadsIdentity;
  const payload = {
    company: data.company,
    id: data.id,
    name: loadsIdentity.name,
    key: loadsIdentity.key,
  };
  dispatch(create(types.RESOURCE_SAVE_BROKER, payload));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'save'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.RESOURCE_SAVE_BROKER, payload));
      } else if (response.code === 500) {
        dispatch(create(types.RESOURCE_REMOVE_BROKER, payload));
      }
    }, () => {
      dispatch(create(types.RESOURCE_REMOVE_BROKER, payload));
    });
};
// hide-broker
export const resourcesRemoveBroker = (data) => (dispatch, getState) => {
  const broker = get(getState().brokers, ['byDOT', data.dot]);
  const loadsIdentity = broker && broker.loadsIdentity;
  const payload = {
    company: data.company,
    id: data.id,
    name: loadsIdentity.name,
    key: loadsIdentity.key,
  };
  dispatch(create(types.RESOURCE_REMOVE_BROKER, payload));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'remove'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.RESOURCE_REMOVE_BROKER, payload));
      } else if (response.code === 500) {
        dispatch(create(types.RESOURCE_SAVE_BROKER, payload));
      }
    }, () => {
      dispatch(create(types.RESOURCE_SAVE_BROKER, payload));
    });
};


export const resourcesLoadSaveBroker = (data) => (dispatch, getState) => {
  const loadsIdentity = resourceId('load', {id: data.loadId});
  const payload = {
    company: data.company,
    id: data.id,
    name: loadsIdentity.name,
    key: loadsIdentity.key,
  };
  dispatch(create(types.RESOURCE_LOAD_SAVE_BROKER, payload));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'save'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.RESOURCE_LOAD_SAVE_BROKER, payload));
      } else if (response.code === 500) {
        dispatch(create(types.RESOURCE_LOAD_REMOVE_BROKER, payload));
      }
    }, () => {
      dispatch(create(types.RESOURCE_LOAD_REMOVE_BROKER, payload));
    });
};
export const resourcesLoadRemoveBroker = (data) => (dispatch, getState) => {
  const loadsIdentity = resourceId('load', {id: data.loadId});
  const payload = {
    company: data.company,
    id: data.id,
    name: loadsIdentity.name,
    key: loadsIdentity.key,
  };
  dispatch(create(types.RESOURCE_LOAD_REMOVE_BROKER, payload));
  companyBroker(getState, {id: data.id, company: data.company, operate: 'remove'})
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.RESOURCE_LOAD_REMOVE_BROKER, payload));
      } else if (response.code === 500) {
        dispatch(create(types.RESOURCE_LOAD_SAVE_BROKER, payload));
      }
    }, () => {
      dispatch(create(types.RESOURCE_LOAD_SAVE_BROKER, payload));
    });
};



// WEBPACK FOOTER //
// ./src/modules/resources/actions.js